import { useState } from 'react';
import { MetricType, EegMetricType } from '../config/chartConfig';

type ActiveView = 'heart' | 'brain';

interface SessionDetailState {
  activeView: ActiveView;
  selectedHeartMetrics: MetricType[];
  selectedBrainMetrics: EegMetricType[];
}

interface SessionDetailActions {
  setActiveView: (view: ActiveView) => void;
  setHeartMetrics: (metrics: MetricType[]) => void;
  setBrainMetrics: (metrics: EegMetricType[]) => void;
  reset: (defaultView?: ActiveView) => void;
}

const DEFAULT_STATE: SessionDetailState = {
  activeView: 'heart',
  selectedHeartMetrics: ['hr'],
  selectedBrainMetrics: ['focus'],
};

export const useSessionDetailState = (
  defaultView: ActiveView = 'heart',
): SessionDetailState & SessionDetailActions => {
  const [activeView, setActiveView] = useState<ActiveView>(defaultView);
  const [selectedHeartMetrics, setHeartMetrics] = useState<MetricType[]>(
    DEFAULT_STATE.selectedHeartMetrics,
  );
  const [selectedBrainMetrics, setBrainMetrics] = useState<EegMetricType[]>(
    DEFAULT_STATE.selectedBrainMetrics,
  );

  const reset = (view: ActiveView = 'heart') => {
    setActiveView(view);
    setHeartMetrics(DEFAULT_STATE.selectedHeartMetrics);
    setBrainMetrics(DEFAULT_STATE.selectedBrainMetrics);
  };

  return {
    activeView,
    selectedHeartMetrics,
    selectedBrainMetrics,
    setActiveView,
    setHeartMetrics,
    setBrainMetrics,
    reset,
  };
};
